// 设备模板信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'UserSkillTasks/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'UserSkillTasks/byData',
        method: 'post',
        data
    })
}

export const auditApi = (data) => {
    return request({
        url: 'UserSkillTasks/toExamine',
        method: 'post',
        data
    })
}